// extracted by mini-css-extract-plugin
module.exports = {"cta":"SalesPosterButtons_cta__VgPSu"};